var map = {
	"./roletpl1.svg": "c7b0",
	"./roletpl10.svg": "7e6f",
	"./roletpl11.svg": "648a",
	"./roletpl12.svg": "6372",
	"./roletpl2.svg": "09d9",
	"./roletpl3.svg": "b820",
	"./roletpl4.svg": "ea6f",
	"./roletpl5.svg": "e623",
	"./roletpl6.svg": "1046",
	"./roletpl7.svg": "930b",
	"./roletpl8.svg": "83a1",
	"./roletpl9.svg": "006a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f69";